module.exports = __webpack_public_path__ + "img/keyboard_X.91646b6a.png";